import React, { useContext, useEffect, useState } from 'react';
import DefaultPageContainer from '../components/DefaultPageContainer';
import { View, Image, StyleSheet, TouchableOpacity } from 'react-native';
import getThemedColor from '../services/get-themed-color';
import ThemeContext from '../context/Theme';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft, faCircleUser } from '@fortawesome/free-solid-svg-icons';
import MyAppText from '../components/MyAppText';
import { translate } from '../services/translate';
import { useNavigationState } from '@react-navigation/native';
import { WindowInformation } from '../services/window-information';
import { useSafeAreaInsets } from 'react-native-safe-area-context';
import UserInformationModal from '../components/UserInformationModal';

const headerHeight = 64;

interface ContactUsComponentProps {
    navigation: Navigation;
    authenticatedUser?: AuthenticatedUser;
    route: object;
}

export default function ContactUs({ navigation, authenticatedUser }: ContactUsComponentProps) {
    const { theme } = useContext(ThemeContext);
    const index = useNavigationState(state => state);
    const [showDropDown, setShowDropDown] = useState<boolean>(false);
    const windowInfo = WindowInformation();
    const insets = useSafeAreaInsets();

    const styles = getStyles(theme);

    useEffect(() => {
        loadMovidesk();
    }, []);

    function goBack() {
        if (index.routes.length > 1) {
            return navigation.goBack();
        }
        window.location.href = '/menu';
    }

    async function loadMovidesk() {
        const env = document.createElement('script');
        env.type = 'text/javascript';
        env.innerHTML = `var mdChatClient="${process.env.MOVIDESK_KEY}";`;

        const widget = document.createElement('script');
        widget.src = 'https://chat.movidesk.com/Scripts/chat-widget.min.js';
        widget.async = true;

        document.body.appendChild(env);
        document.body.appendChild(widget);
    }

    return (
        <DefaultPageContainer>
            <View style={styles.headerBar}>
                <View style={{ width: 24, height: 24 }}>
                </View>
                <View style={{
                    flex: 1,
                    justifyContent: 'center',
                    alignItems: 'center',
                }}>
                    {windowInfo.isMobile ?
                        <Image source={require(`../../assets/smartsampa_logo_${theme}.png`)} style={styles.headerLogo} />
                        : <Image source={require(`../../assets/big_smartsampa_logo_${theme}.png`)} style={styles.bigHeaderLogo} />
                    }                </View>
                <TouchableOpacity onPress={() => setShowDropDown(!showDropDown)}>
                    <FontAwesomeIcon icon={faCircleUser} color={getThemedColor(theme, '#000000')} fontSize={24} />
                </TouchableOpacity>
            </View>
            <View style={[styles.container, {
                width: windowInfo.width,
                height: windowInfo.height - headerHeight - insets.top - insets.bottom,
            }]}>
                <View style={styles.header}>
                    <View style={{ alignItems: 'center', flexDirection: 'row', flexGrow: 1, minWidth: 200, columnGap: 10 }}>
                        <TouchableOpacity onPress={goBack}>
                            <FontAwesomeIcon fontSize={22} icon={faArrowLeft} color={getThemedColor(theme, '#000028')} />
                        </TouchableOpacity>
                        <MyAppText style={{ fontSize: 24, color: getThemedColor(theme, '#58595B'), fontWeight: 'bold' }}>
                            {translate('contactUs')}
                        </MyAppText>
                    </View>
                </View>
                <View style={styles.cardList}>
                    <MyAppText>{translate('movideskInformationPage')}</MyAppText>
                </View>
            </View>
            <UserInformationModal acceptedTermsOfUse={authenticatedUser?.acceptedTermsOfUse || false}
                showDropDown={showDropDown} setShowDropDown={setShowDropDown} navigation={navigation} />
        </DefaultPageContainer>
    );
}

function getStyles(theme: Theme) {
    return StyleSheet.create({
        container: {
            rowGap: 15,
            padding: 10
        },
        headerBar: {
            height: headerHeight,
            backgroundColor: getThemedColor(theme, '#FFFFFF'),
            border: `1px solid ${getThemedColor(theme, '#E6E6E6')}`,
            justifyContent: 'center',
            alignItems: 'center',
            flexDirection: 'row',
            paddingHorizontal: 14
        },
        headerLogo: {
            height: 40,
            width: 275,
        },
        bigHeaderLogo: {
            height: 40,
            width: 700,
        },
        header: {
            flexDirection: 'row',
            alignItems: 'center',
            gap: 10,
            flexWrap: 'wrap',
            minHeight: 65
        },
        cardList: {
            borderWidth: 1,
            borderRadius: 8,
            borderColor: getThemedColor(theme, '#E6E6E6'),
            padding: 24,
            backgroundColor: getThemedColor(theme, '#FFFFFF'),
            flex: 1,
        },
    });
}
